import type { MetricData } from 'src/redux/admin/reporting/reporting.types';

export interface MetaResultsBreakdownEntry {
  indicator?: string | null;
  label?: string | null;
  results?: number | null;
}

export function formatMetaResultsValue(
  results: number | null | undefined,
  mixed?: boolean,
): string {
  if (mixed) {
    return '—';
  }
  if (results === null || typeof results === 'undefined') {
    return '—';
  }
  return String(results);
}

export function shouldShowResultsMetricCard(
  current?: Pick<
    MetricData,
    'results' | 'results_mixed' | 'results_by_indicator' | 'result_indicator'
  > | null,
): boolean {
  if (!current) {
    return false;
  }
  if (current.results_mixed) {
    return Boolean(current.results_by_indicator?.length);
  }
  if (current.results === null) {
    return false;
  }
  return typeof current.results !== 'undefined' && current.results !== 0;
}

export function getMetaResultsIndicatorLabel(
  current?: Pick<MetricData, 'result_indicator_label' | 'results_mixed'> | null,
): string | undefined {
  if (!current || current.results_mixed) {
    return undefined;
  }
  return current.result_indicator_label ?? undefined;
}
